<template>
    <div class="d-flex flex-column bg-white px-4 px-md-5 py-4 w-100" style="max-width: 492px">

        <div class="d-flex align-items-end flex-row justify-content-center w-100 mb-3">
            <i class="fas fa-shopping-cart fa-2x mr-3"></i>
            <h4 class="font-weight-light text-center mb-1 font-weight-bold text-uppercase">Secure Check Out</h4>
        </div>

        <router-link class="small" :to="{path: '/card-registration'}"><i class="fa-arrow-left fa mr-1"></i>Back
        </router-link>

        <b-card body-class="p-0" class="mt-3 mb-0">
            <template name="header">
                <div class="bg-light d-flex justify-content-between px-4 py-2 border-bottom">
                    <p class="mb-0">Item</p>
                    <p class="mb-0">Price</p>
                </div>
            </template>
            <b-list-group class="px-4" flush>

                <b-list-group-item
                        class="px-0"
                        :class="{'border-top-0' : index === 0}"
                        v-for="(item, index) in items"
                        :key="index">
                    <b-row class="no-gutters">
                        <b-col sm="7">
                            <h5 class="text-uppercase">{{item.title}}</h5>
                            <p class="small mb-0">{{item.desc}}</p>
                        </b-col>
                        <b-col class="text-right">
                            <p class="text-muted mb-0"><s>{{item.old_price}}</s></p>
                            <p class="font-weight-bold">{{item.amount}}</p>
                        </b-col>
                    </b-row>
                </b-list-group-item>

            </b-list-group>
        </b-card>


        <div class="py-3">
            <b-button v-if="!discount && !discountValid"
                      class="align-self-start p-0 mb-1"
                      size="sm" variant="link"
                      @click="discount = !discount">
                <u>I have a discount code</u>
            </b-button>

            <p v-else-if="!discount && discountValid" class="text-success my-3 d-flex align-items-center">
                <span class="d-inline-block">Discount code applied:</span><span class="ml-1 d-inline-block"
                                                                                style="max-width: 54px; overflow: hidden">{{form.discount}}</span>
                <i
                        @click="deleteDiscount"
                        class="far fa-times-circle text-danger fa-lg ml-1"
                        style="cursor: pointer"></i>
            </p>

            <b-form v-else class="w-100 d-flex flex-row mb-3 mt-2">
                <b-input
                        v-model="form.discount"
                        id="email"
                        type="email"
                        class="w-100 rounded"
                        name="promo-code"
                        placeholder="Enter your promo code">
                </b-input>
                <b-button
                        variant="outline-primary"
                        @click="sendDiscount"
                        class="ml-2">
                    <p class="text-uppercase small mb-0 px-4">Apply</p>
                </b-button>
            </b-form>

            <b-row class="justify-content-between py-2">
                <b-col>
                    <h6 class="text-uppercase">Total:</h6>
                </b-col>
                <b-col>
                    <h6 class="text-right text-uppercase"><span class="text-muted mr-2" style="opacity: .4">({{currency}})</span>$80/month
                    </h6>
                </b-col>
            </b-row>
        </div>

        <b-card header="Payment details" class="mb-3">

            <b-form v-if="!createCard">

                <b-form-radio-group
                        v-model="cardSelected">
                    <b-form-radio
                            v-for="(card, index) in cards"
                            :key="index"
                            name="credit-card"
                            :value="card.id"
                            :id="card.id"
                            class="mb-2"
                    >
                        <label :for="card.id" class="ml-2">
                            <i :class="`fab fa-cc-${normilizeClassName(card.card_brand)} fa-lg mr-2 ml-2 text-muted`"></i>
                            {{`**** **** **** ${card.card_last4}`}}
                        </label>
                    </b-form-radio>
                </b-form-radio-group>

                <b-button class="mt-3 text-uppercase" variant="outline-primary"
                          @click="createCard = !createCard, cardIsSelected = !cardIsSelected">
                    <p class="small mb-0 py-1 px-4">+ Add a new card</p>
                </b-button>

            </b-form>

            <b-form v-else>
                Add your form here
            </b-form>

        </b-card>

        <div class="w-100 px-4">
            <b-button
                    class="w-100 btn-lg mt-3 text-uppercase p-2"
                    variant="primary"
                    :disabled="!cardIsSelected"
                    @click="">
                <p class="small mb-1 mt-1">Place your order</p>
            </b-button>
        </div>

    </div>
</template>

<script>
    export default {
        name: "cardRegistration",
        data() {
            return {
                currency: 'USD',
                items: [
                    {
                        title: "Professional",
                        desc: 'Access to all that PSFK has to offer including report access and on- demand research services.',
                        old_price: `$41/Month`,
                        amount: `$40/Month`
                    },
                    {
                        title: "Basic monthly",
                        desc: 'Access to all that PSFK has to offer including report access and on- demand research services.',
                        old_price: `$42/Month`,
                        amount: `$40/Month`
                    }
                ],
                cards: [
                    {
                        card_brand: "Visa",
                        card_last4: "1881",
                        id: '1',
                        default: true
                    },
                    {
                        card_brand: "Master Card",
                        card_last4: "7586",
                        id: '2',
                        default: false
                    }
                ],
                form: {
                    discount: ''
                },
                addCard: false,
                discount: false,
                createCard: false,
                cardIsSelected: true,
                cardSelected: '1',
                discountValid: false
            }
        },
        methods: {
            normilizeClassName(string) {
                return string.toLowerCase().replace(' ', '')
            },
            sendDiscount() {
                this.discountValid = true;
                this.discount = false
            },
            deleteDiscount() {
                this.form.discount = '';
                this.discount = false;
                this.discountValid = false;
            }
        }
    }
</script>